/* eslint-disable @typescript-eslint/no-extraneous-class */
export class FormElements {
    static readonly searchIcon = "<img src='icons/search.png' style='vertical-align: middle;'>";

    public static button(icon: string, label: string, name: string) {
        return {
            type: 'button',
            value: "<img src='icons/" + icon + ".png' style='vertical-align: middle;'>" + ' ' + label,
            name: name,
        };
    }

    public static verifyQueryTimes(time1: number, time2: number) {
        if (time1 == null || time2 == null) {
            dhtmlx.message({
                title: 'Missing Information',
                text: 'Please select start/end times.',
                type: 'alert-error',
            });
            return false;
        }
        return true;
    }
}
